import React from 'react';
import PropTypes from 'prop-types';

import Ambassador from '../../../../components/ambassador/Ambassador.jsx';
import AmbassadorForm from './AmbassadorForm.jsx';

import i18n from '../../../../../shared/locales/no.json';

export default class AmbassadorEditable extends React.Component {
    static propTypes = {
        id: PropTypes.number,
        onRemove: PropTypes.func.isRequired,
    };

    state = {
        showForm: false,
    };

    handleRemove = () => {
        this.props.onRemove(this.props.id);
    };

    handleCompletion = () => {
        this._hideForm();
    };

    handleCancel = () => {
        this._hideForm();
    };

    _showForm = () => {
        this.setState({ showForm: true });
    };

    _hideForm() {
        this.setState({ showForm: false });
    }

    render() {
        return this.state.showForm ? (
            <AmbassadorForm
                {...this.props}
                onCancel={this.handleCancel}
                onCompletion={this.handleCompletion}
            />
        ) : (
            <Ambassador {...this.props}>
                <div className="u-pb4">
                    <button
                        className="button button--link u-mr16"
                        onClick={this._showForm}
                    >
                        {i18n.ambassadors.edit_ambassador}
                    </button>

                    <button
                        className="button button--destructive-flat"
                        onClick={this.handleRemove}
                    >
                        {i18n.ambassadors.remove_ambassador}
                    </button>
                </div>
            </Ambassador>
        );
    }
}
